module.exports = __webpack_public_path__ + "img/users-icon.499fcd85.svg";